'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');let

TableColumn=function(){
function TableColumn(){let label=arguments.length>0&&arguments[0]!==void 0?arguments[0]:'';let orderByDefinition=arguments.length>1&&arguments[1]!==void 0?arguments[1]:[];let defaultAscending=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!0;let finalSort=arguments.length>3&&arguments[3]!==void 0?arguments[3]:[];let isInitiallyActive=arguments.length>4&&arguments[4]!==void 0?arguments[4]:!1;let columnClass=arguments.length>5&&arguments[5]!==void 0?arguments[5]:'';_classCallCheck(this,TableColumn);
this._label=label;
this._isAscendingByDefault=defaultAscending;
this._ascending=defaultAscending;
this._sortDisabled=!_.exists(orderByDefinition)||orderByDefinition.length===0;

this._setOrderArrays(orderByDefinition,finalSort);

if(isInitiallyActive){
this.sort();
}

this._columnClass=columnClass;
}TableColumn.prototype.

_setOrderArrays=function _setOrderArrays(orderByDefinition,finalSort){
if(this._sortDisabled){
this._sortOrders={
ascending:[],
descending:[]};

}else if(_.isArray(orderByDefinition)){
this._sortOrders={
ascending:orderByDefinition.concat(finalSort),
descending:this._reverseSortOrder(orderByDefinition).concat(finalSort)};

}else if(_.isObject(orderByDefinition)){
if(!_.hasAllKeys(orderByDefinition,['ascending','descending'])){
throw new Error('Column "orderBy" object definition must have both "ascending" and "descending" keys.');
}

this._sortOrders={
ascending:orderByDefinition.ascending.concat(finalSort),
descending:orderByDefinition.descending.concat(finalSort)};

}else{
throw new Error('Column "orderBy" object definition must be an array, or an object.');
}
};TableColumn.prototype.

_invert=function _invert(value){var _this=this;
if(_.isFunction(value)){
return function(v){return _this._invert(value(v))};
}

if(_.isBoolean(value)){
return!value;
}

if(_.isNumber(value)){
return-1*value;
}

if(_.isString(value)){
return value[0]==='-'?value.replace(/^-/,''):`-${value}`;
}

throw new Error(`Not sure how to invert this value: ${value}`);
};TableColumn.prototype.

_reverseSortOrder=function _reverseSortOrder(sortOrder){var _this2=this;
return sortOrder.map(function(sortValue){return _this2._invert(sortValue)});
};TableColumn.prototype.

sort=function sort(){
if(this._isActive){
this._ascending=!this._ascending;
}

this._isActive=!0;
this._orderBy=this._ascending?this._sortOrders.ascending:this._sortOrders.descending;
};TableColumn.prototype.

endSort=function endSort(){
this._isActive=!1;
this._ascending=this._isAscendingByDefault;
};TableColumn.

























fromColumnDefinition=function fromColumnDefinition(columnDef){
const{label:label,defaultAscending:defaultAscending,orderBy:orderBy,finalSort:finalSort,isInitiallyActive:isInitiallyActive,columnClass:columnClass}=columnDef;

return new TableColumn(label,orderBy,defaultAscending,finalSort,isInitiallyActive,columnClass);
};_createClass(TableColumn,[{key:'label',get:function(){return this._label}},{key:'ascending',get:function(){return this._ascending}},{key:'isActive',get:function(){return this._isActive}},{key:'orderBy',get:function(){return this._orderBy}},{key:'sortDisabled',get:function(){return this._sortDisabled}},{key:'columnClass',get:function(){return this._columnClass}}]);return TableColumn}();


module.exports=TableColumn;
//# sourceMappingURL=tableColumn.js.map
